// Spinner.tsx

import styles from './Spinner.module.css'; // Updated to use .module.css

export default function Spinner() {
  return <div className={styles.spinner}></div>;
}
